import React from "react";
import { connect } from "react-redux";
import Select from "react-dropdown-select";
import "../Forms/css/register.css"
import Registration from "../../screens/Auth/Registration";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import axios from "axios";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
const  token = localStorage.getItem('authToken');

class EditRegister extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      textInput: "",
      name: "",
 
      city: '',
      area: '',
      state: '',
      phoneNumber: '',
      password: '',
      drugLicense: null,
      shopImage: null,
      gstin: '',
      commission: '',
      errors: {},
      emailInput: "",
      areaInput: "",
      selectedBusinessType: "",
      submeet: false,
      showPassword: false,
      agreeToTerms: false,
      submissionStatus: null,
      accountType: 'retailer',
    };
  }
  async componentDidMount() {
    const { match } = this.props;
    if (match && match.params && match.params.id) {
      const { id } = match.params;
      this.setState({ id });
      await this.fetchData(id);
    } else {
      console.error("No match or id found in props");
    }
  }

  fetchData = async (id) => {
    console.log("Fetch data called with id:", id);
    try {
      const response = await axios.get(`https://brand.aasmo.in/api/admin/getbyid-user/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
     
      const userData = response?.data;
      console.log("Fetch data response:", userData);
      if (userData) {
        this.setState({
        
          textInput: userData.firstName|| '',
          name: userData?.lastName|| '',
        
          city: userData?.city|| '',
        
          phoneNumber: userData?.phoneNumber|| '',
        
          
      
        });
      } else {
        console.error("No user data found");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  
  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
      submitted: false,
    });
  };

  handleFileChange = (e) => {
    const { name, files } = e.target;
    this.setState({
      [name]: files[0],
      submitted: false,
    });
  };

  validateForm = () => {
    const { city, area, state, phoneNumber, agreeToTerms, drugLicense, shopImage, gstin, commission, accountType } = this.state;
    const errors = {};
    let isValid = true;

    if (!city) {
      errors.city = 'City is required';
      isValid = false;
    }

    if (!area) {
      errors.area = 'Area is required';
      isValid = false;
    }

    if (!state) {
      errors.state = 'State is required';
      isValid = false;
    }

    if (!phoneNumber.match(/^\d{10}$/)) {
      errors.phoneNumber = 'Mobile number must be exactly 10 digits';
      isValid = false;
    }

   
    if (!drugLicense) {
      errors.drugLicense = 'Drug License is required';
      isValid = false;
    }

    if (!shopImage) {
      errors.shopImage = 'Shop Image is required';
      isValid = false;
    }

    if (accountType === 'wholesaler' && !commission) {
      errors.commission = 'Commission is required';
      isValid = false;
    }

    if (!agreeToTerms) {
      errors.agreeToTerms = 'You must agree to the terms and conditions.';
      isValid = false;
    }

    this.setState({ errors });
    return isValid;
  };


  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ submitted: true });

    const { id } = this.state;
    try {
        const formData = new FormData();
        const { city, phoneNumber, textInput, name } = this.state;

        formData.append('city', city);
        formData.append('phoneNumber', phoneNumber);
        formData.append('firstName', textInput);
        formData.append('lastName', name);

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        };

        const response = await axios.put(`https://brand.aasmo.in/api/admin/update-user/${id}`, formData, config);

        // Change 201 to 200
        if (response && (response.status === 200 || response.status === 204)) {
            this.setState({ submissionStatus: 'success' });
            // Optionally reset the form or clear fields here if needed
            setTimeout(() => {
                window.location.href = "/list";
            }, 2000);
        } else {
            console.log('Unexpected response:', response);
            this.setState({ submissionStatus: 'error' }); // Optionally set an error status
        }
    } catch (error) {
        console.error('Error submitting form:', error);
        if (error.response) {
            const { status, data } = error.response;
            if (status === 400) {
                console.error('Bad request error:', data);
            } else if (status === 401) {
                console.error('Unauthorized error, please log in again.');
            } else {
                console.error('Error response:', error.response);
            }
            this.setState({ submissionStatus: 'error' }); // Set error status if an error occurs
        } else {
            console.error('Network or other error:', error);
            this.setState({ submissionStatus: 'error' }); // Set error status if an error occurs
        }
    }
};



  render() {
    const { city, area, state, phoneNumber, submissionStatus, accountType, agreeToTerms, showPassword, drugLicense, shopImage, gstin, errors, submitted, textInput, name, selectedBusinessType, emailInput, areaInput, submeet, commission } = this.state;
    return (
      <div className="col-md-12">
        <div className="card">
          <div className="header">
            <h2>Edit</h2>
          </div>
          <div className="body">
            <form>
              <div className="form-group">
                <label>First Name</label>
                <input
                  className={`form-control ${textInput === "" && submitted ? "parsley-error" : ""}`}
                  value={textInput}
                  name="textInput"
                  required
                  onChange={this.handleChange}
                />
                {textInput === "" && submitted ? (
                  <ul className="parsley-errors-list filled">
                    <li className="parsley-required">This value is required.</li>
                  </ul>
                ) : null}
              </div>
              <div className="form-group">
                <label>Last Name</label>
                <input
                  className={`form-control ${name === "" && submitted ? "parsley-error" : ""}`}
                  value={name}
                  name="name"
                  required
                  onChange={this.handleChange}
                />
                {name === "" && submitted ? (
                  <ul className="parsley-errors-list filled">
                    <li className="parsley-required">This value is required.</li>
                  </ul>
                ) : null}
              </div>
              <div className="form-group">
                <label>Phone No</label>
                <input
                  type="text"
                  className={`form-control ${phoneNumber.length !== 10 && submitted ? "parsley-error" : ""}`}
                  value={phoneNumber}
                  name="phoneNumber"
                  maxLength="10"
                  pattern="\d{10}"
                  required
                  onChange={this.handleChange}
                />
                {phoneNumber.length !== 10 && submitted ? (
                  <ul className="parsley-errors-list filled">
                    <li className="parsley-required">phoneNumber must be exactly 10 digits.</li>
                  </ul>
                ) : null}
              </div>
              <div className="form-group">
                <label>City</label>
                <input
                  type="text"
                  className={`form-control ${errors.city ? "parsley-error" : ""}`}
                  name="city"
                  value={city}
                  onChange={this.handleChange}
                />
                {errors.city && submitted && <div className="parsley-errors-list">{errors.city}</div>}
              </div>
          
              {submissionStatus === 'success' && (
              <div className="alert alert-success">Form submitted successfully!</div>
            )}
              <button type="button" onClick={this.handleSubmit} className="btn btn-primary">Submit</button>
            </form>
          
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ mailInboxReducer }) => ({});

export default withRouter(EditRegister);
